module.exports = __webpack_public_path__ + "img/player.b68f9e5e.png";